import {
  ServiceCheckUsageDetailedModel,
  ServiceCheckUsageDetailedParams,
  ServiceCheckUsageModel,
  ServiceCheckUsageParams,
  ServiceFetchMetadataModel,
  ServiceFetchMetadataParamsWithServiceValue,
  ServiceFetchMetadataParamsWithUserValue
} from '@aipb/gulliver/personal-content/model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonalContentApiService } from '../personal-content-api.service';
import { ServiceApiInterface } from './service-api.interface';

@Injectable({
  providedIn: 'root'
})
export class ServiceApiService implements ServiceApiInterface {
  constructor(private api: PersonalContentApiService) {}

  checkUsage(params: ServiceCheckUsageParams): Observable<ServiceCheckUsageModel> {
    return this.api.post('serviceCheckUsage', params);
  }

  checkUsageDetailed(params: ServiceCheckUsageDetailedParams): Observable<ServiceCheckUsageDetailedModel> {
    return this.api.post('serviceCheckUsage_detailed', params);
  }

  fetchMetadata(
    params: ServiceFetchMetadataParamsWithServiceValue | ServiceFetchMetadataParamsWithUserValue
  ): Observable<ServiceFetchMetadataModel> {
    return this.api.post('serviceFetchMetadata', params);
  }
}
